import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import Carousel from './components/Carousel';
import Index from './components/Index';
import Media from './components/Media';
import FAQ from './components/FAQ';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import App from './components/App';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <Carousel />
        <Index />
        <Media />
        <FAQ />
        <Updates />
        <Ranking />
        <Cards />
        <App />
        <Features />
        <About />
        <Contact />
        <Topics />
      </main>
      <Footer />
    </>
  );
}